import { Dumbbell, Footprints, CircleDot, Goal, Dribbble, Bike, Table2 } from "lucide-react";

export const SPORT_ICONS = {
  gym: Dumbbell,
  running: Footprints,
  tennis: CircleDot,
  football: Goal,
  basketball: Dribbble,
  padel: CircleDot,
  cycling: Bike,
  "table-tennis": Table2,
};

export const SPORTS = [
  { slug: "gym", name: "Gym", description: "Strength training, weightlifting and functional fitness." },
  { slug: "running", name: "Running", description: "Road, trail and track running for every distance." },
  { slug: "tennis", name: "Tennis", description: "Singles and doubles on court, all skill levels." },
  { slug: "football", name: "Football", description: "The beautiful game — 5-a-side to full pitch." },
  { slug: "basketball", name: "Basketball", description: "Pickup games, drills and league play." },
  { slug: "padel", name: "Padel", description: "Fast-growing racket sport, fun and social." },
  { slug: "cycling", name: "Cycling", description: "Road, indoor and group rides to build endurance." },
  { slug: "table-tennis", name: "Table Tennis", description: "Quick reflexes, big fun — rally with a partner." },
];
